



























import {Component, Vue} from 'vue-property-decorator';
import Card from '@c/Card.vue';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {pmoduleStoresByTypeMap, pmoduleDeveloperInfoTabs} from '@/views/system/modules/configurate';
import {PModuleType} from '@/enums/configs';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import Loading from '@c/controls/Loading.vue';
import PModuleButtons from './PModuleButtons.vue';

@Component({
  components: {
    Card,
    Loading,
    PModuleButtons,
  },
})
export default class PModuleDeveloperInfo extends Vue {
  // Программный модуль
  pmodule: PModuleWithMeasurements | null = null;

  // Показатели загрузки данных и ошибки
  loading = true;
  error = false;

  get tabs() {
    if (this.isFictionModule()) return pmoduleDeveloperInfoTabs.filter((t: any) => t.tab != 'log');
    return pmoduleDeveloperInfoTabs;
  }

  tab = this.tabs[0];

  // Получить хранилище
  get apiStore(): PModuleStoreModule {
    return (pmoduleStoresByTypeMap.get(
      ((this as any).$route.meta.type as any) as PModuleType,
    ) as any) as PModuleStoreModule;
  }

  // TODO: Вынести этот код в mixin
  async created() {
    try {
      const {data} = await this.apiStore.getById(this.$route.params.id);
      this.pmodule = data as PModuleWithMeasurements;
      if (!this.pmodule) return;
    } catch (e) {
      console.error(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  isFictionModule() {
    if (!this.pmodule) return;
    return [
      PModuleType.MonitorStatesTasks,
      PModuleType.MonitorBoundaryTasks,
      PModuleType.MonitorChildTasks,
      PModuleType.SignalTrendTasks,
    ].includes(this.pmodule.type);
  }

  // beforeDestroy() {}
}
